export default function getWhiteOrBlackColor(bgColor) {
    if (!bgColor) return 'black';
    const hex = bgColor.replace('#', '');
    const color_red = parseInt(hex.substr(0, 2), 16);
    const color_green = parseInt(hex.substr(2, 2), 16);
    const color_blue = parseInt(hex.substr(4, 2), 16);
    const brightness = (color_red * 299 + color_green * 587 + color_blue * 114) / 1000;
    return brightness > 155 ? 'black' : 'white';
}
